// extracted by mini-css-extract-plugin
export default {"card":"Y0-z"};